import { create } from "zustand";

export type VersionCheckSource = "frontend" | "backend";

interface MarkOutdatedDetail {
  source: VersionCheckSource;
  oldVersion: string | number;
  newVersion: string | number;
}

interface VersionCheckState {
  outdated: boolean;
  source: VersionCheckSource | null;
  oldVersion: string | number | null;
  newVersion: string | number | null;
  backendBaseline: number | null;
  markOutdated: (detail?: MarkOutdatedDetail) => void;
  setBackendBaseline: (value: number) => void;
}

export const useVersionCheckStore = create<VersionCheckState>((set, get) => ({
  outdated: false,
  source: null,
  oldVersion: null,
  newVersion: null,
  backendBaseline: null,
  markOutdated: detail => {
    if (get().outdated) return;
    set({
      outdated: true,
      source: detail?.source ?? null,
      oldVersion: detail?.oldVersion ?? null,
      newVersion: detail?.newVersion ?? null
    });
  },
  setBackendBaseline: value => {
    if (get().backendBaseline !== null) return;
    set({ backendBaseline: value });
  }
}));
